import { bindEvents, getRootOffsetBounds, lodash } from '../helpers';

class ResizeController {

	constructor() {

		// class method groups

		this.coords = {
			section: []
		};

		this.throttled = {
			measure: null
		};

		this.sections = []; // elements being tracked
		this.subscribers = []; // objects following update / render calls

		// bind events to class
		this.events = bindEvents(this);
	}

	// initialize

	initialize(sections) {
		if (sections) {
			for (let i = 0; i < sections.length; i++) {
				this.sections.push(sections[i]);
			}
		}

		this.throttled.measure = lodash.throttle(this._measureNow.bind(this), 500, { leading: false, trailing: true });

		this.addEventListeners();
	}

	// listeners

	addEventListeners() {
		window.addEventListener('load', this.events._onWindowLoad);
		window.addEventListener('resize', this.events._onWindowResize);

		this.measure(true);
	}

	removeEventListeners() {
		window.removeEventListener('load', this.events._onWindowLoad);
		window.removeEventListener('resize', this.events._onWindowResize);
	}

	// listener methods

	_onWindowLoad() {
		this.measure();
	}

	_onWindowResize() {
		this.measure();
	}

	//

	measure(instant = false) {
		if (instant) {
			this._measureNow();
		} else {
			this.throttled.measure();
		}
	}

	_measureNow() {
		// console.log('measure');
		for (let i = 0; i < this.sections.length; i++) {
			const $section = this.sections[i];
			this.coords.section[i] = getRootOffsetBounds($section);
		}

		this.update();
		this.render();
	}

	// update / render subscription

	set(obj) {
		obj.updated = false;
		this.subscribers.push(obj);
		return this.subscribers.length - 1;
	}

	clear(index) {
		this.subscribers[index] = null;
	}

	// update / render

	update() {
		for (let i = 0, l = this.subscribers.length; i < l; ++i) {
			const subscriber = this.subscribers[i];
			if (subscriber && subscriber.update(this.coords)) subscriber.updated = true;
		}
	}

	render() {
		for (let i = 0, l = this.subscribers.length; i < l; ++i) {
			const subscriber = this.subscribers[i];
			if (subscriber && subscriber.updated) {
				subscriber.updated = false;
				subscriber.render(this.coords);
			}
		}
	}

	// getters

	get wrapperHeight() {
		return this.coords.wrapper.height;
	}

}

export default new ResizeController();
